import { render, staticRenderFns } from "./my_comment_course.vue?vue&type=template&id=1f7cd276&scoped=true"
import script from "./my_comment_course.vue?vue&type=script&lang=js"
export * from "./my_comment_course.vue?vue&type=script&lang=js"
import style0 from "./my_comment_course.vue?vue&type=style&index=0&id=1f7cd276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7cd276",
  null
  
)

export default component.exports